import React from 'react';
import {
	Card,
	Col,
	Row,
} from 'antd';
import NewFleetTimeline from '../components/NewFleetTimeline';
import { DashboardComponent } from '../helpers/dashboardInfo';
import styles from './FleetTimelineDashboard.module.css';

const FleetTimelineDashboard: DashboardComponent = ({
	setLastUpdated,
}) => {
	return (
		<Row gutter={[16, 16]}>
			<Col span={24}>
				<Card title={(
					<div>
						Fleet Timeline
						<span className={styles.fleetTimelineLabel}> (All times are shown UTC)</span>
					</div>
				)}
				>
					<NewFleetTimeline setLastUpdated={setLastUpdated} />
				</Card>
			</Col>
		</Row>
	);
};

export default FleetTimelineDashboard;
